import onlinePayment1 from './assets/onlinePayment1.jpg';
import onlinePayment2 from './assets/onlinePayment2.jpg';
import onlinePayment3 from './assets/onlinePayment3.jpg';
import onlinePayment4 from './assets/onlinePayment4.jpg';
import onlinePayment5 from './assets/onlinePayment5.png';
import paymentPlace1 from './assets/paymentPlace1.jpg';
import paymentPlace2 from './assets/paymentPlace2.jpg';
import paymentPlace3 from './assets/paymentPlace3.jpg';
import paymentPlace4 from './assets/paymentPlace4.jpg';
import paymentPlace5 from './assets/paymentPlace5.jpg';
import paymentPlace6 from './assets/paymentPlace6.jpg';

export const USER_EMAIL = 'email';
export const CLIENT_NUMBER = 'clientNumber';
export const DOCUMENT_NUMBER = 'document_number';
export const DOCUMENT_TYPE = 'document_type';
export const FORM_NAME = 'public_payments';
export const GENDER = 'gender';
export const NIS = 'nis';

export const onlinePaymentPlaces = [
  {
    id: 'onlinePayment1',
    src: onlinePayment1,
    title: 'Red Link',
    link: 'https://www.redlink.com.ar'
  },
  {
    id: 'onlinePayment2',
    src: onlinePayment2,
    title: 'Red Banelco',
    link: 'https://pagomiscuentas.com'
  },
  {
    id: 'onlinePayment3',
    src: onlinePayment3,
    title: 'Tarjeta Visa',
    link: 'http://www.visa.com.ar'
  },
  {
    id: 'onlinePayment4',
    src: onlinePayment4,
    title: 'Tarjeta MasterCard',
    link: 'https://masterconsultas.com.ar'
  },
  {
    id: 'onlinePayment5',
    src: onlinePayment5,
    title: 'Mercado Pago',
    link: 'https://www.mercadopago.com.ar/'
  }
];

export const paymentPlaces = [
  {
    id: 'paymentPlace1',
    src: paymentPlace1,
    title: 'Provincia Net'
  },
  {
    id: 'paymentPlace2',
    src: paymentPlace2,
    title: 'Rapi Pago'
  },
  {
    id: 'paymentPlace3',
    src: paymentPlace3,
    title: 'Red Ripsa'
  },
  {
    id: 'paymentPlace4',
    src: paymentPlace4,
    title: 'Pago Fácil'
  },
  {
    id: 'paymentPlace5',
    src: onlinePayment1,
    title: 'Cajeros Link'
  },
  {
    id: 'paymentPlace6',
    src: paymentPlace5,
    title: 'Cajeros Banelco'
  },
  {
    id: 'paymentPlace7',
    src: paymentPlace6,
    title: 'Cobro-express'
  }
];
